import { RootState } from 'store';

const SahClientContributionsState = (state: RootState) => state.supportAtHome.clientContributions;

export const selectSahClientContributions = (state: RootState) => SahClientContributionsState(state).rows;
export const selectSahClientContributionsGrouped = (state: RootState) => SahClientContributionsState(state).grouped;

export const selectLoading = (state: RootState) => SahClientContributionsState(state).loading;
export const selectErrorResponse = (state: RootState) => SahClientContributionsState(state).error;
export const selectUploadError = (state: RootState) => SahClientContributionsState(state).uploadError;
